<template>
  <admin-page-frame>
    <school-list-toolbar @search="loadList" @reset="handleReset">
      <template #actions>
        <el-button class="filter-item" size="mini" icon="el-icon-menu" @click="openCategoryMgr">分类管理</el-button>
        <el-button class="filter-item" type="primary" size="mini" icon="el-icon-plus" @click="openForm()">新增教室</el-button>
      </template>
      <template #filters>
        <el-input v-model="query.keyword" clearable size="small" placeholder="名称/编码/位置" class="filter-item" style="width: 180px; margin-right: 10px;" @keyup.enter.native="loadList" />
        <el-select v-model="query.categoryId" clearable filterable size="small" placeholder="分类" class="filter-item" style="width: 140px; margin-right: 10px;">
          <el-option v-for="c in categoryOptions" :key="c.id" :label="c.categoryName" :value="c.id" />
        </el-select>
        <el-select v-model="query.ownershipType" clearable size="small" placeholder="产权" class="filter-item" style="width: 110px; margin-right: 10px;">
          <el-option label="自有" value="owned" /><el-option label="租赁" value="rented" />
        </el-select>
        <el-select v-model="query.status" clearable size="small" placeholder="状态" class="filter-item" style="width: 100px; margin-right: 10px;">
          <el-option label="启用" :value="1" /><el-option label="停用" :value="0" />
        </el-select>
      </template>
    </school-list-toolbar>

    <el-table v-loading="loading" :data="list" :border="false" size="small" style="width: 100%;">
      <el-table-column prop="roomName" label="教室名称" min-width="120" show-overflow-tooltip />
      <el-table-column prop="roomCode" label="编码" width="100" show-overflow-tooltip />
      <el-table-column prop="categoryName" label="分类" width="110" show-overflow-tooltip />
      <el-table-column prop="floor" label="楼层" width="70" />
      <el-table-column prop="capacity" label="容量" width="70" align="center" />
      <el-table-column label="设施" min-width="160" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <el-tag v-for="tag in (row.facilityTags || [])" :key="tag" size="mini" style="margin-right: 4px;">{{ tag }}</el-tag>
          <span v-if="!(row.facilityTags && row.facilityTags.length)" style="color:#c0c4cc;">-</span>
        </template>
      </el-table-column>
      <el-table-column label="产权" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag :type="row.ownershipType === 'rented' ? 'warning' : 'success'" size="mini">{{ ownershipLabel(row.ownershipType) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="租赁期" min-width="170" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span v-if="row.ownershipType === 'rented'">{{ row.rentStartDate || '-' }} ~ {{ row.rentEndDate || '-' }}</span>
          <span v-else style="color:#c0c4cc;">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="location" label="位置" min-width="120" show-overflow-tooltip />
      <el-table-column label="状态" width="70" align="center">
        <template slot-scope="{ row }"><el-tag :type="row.status === 1 ? 'success' : 'info'" size="mini">{{ row.status === 1 ? '启用' : '停用' }}</el-tag></template>
      </el-table-column>
      <el-table-column label="操作" width="80" align="center" fixed="right" class-name="admin-pc-table-actions-col">
        <template slot-scope="{ row }"><div class="admin-pc-table-actions"><el-button type="text" size="mini" @click="openForm(row)">编辑</el-button></div></template>
      </el-table-column>
    </el-table>
    <school-list-pagination :total="total" :page="query.page" :size="query.size" @page-change="onPageChange" @size-change="onSizeChange" />

    <el-dialog :title="form.id ? '编辑教室' : '新增教室'" :visible.sync="formVisible" width="720px" top="5vh" :close-on-click-modal="false" @closed="resetForm">
      <el-form ref="formRef" :model="form" :rules="formRules" label-width="100px" size="small" class="admin-pc-dialog-form">
        <el-divider content-position="left">基本信息</el-divider>
        <el-row :gutter="12">
          <el-col :span="12"><el-form-item label="教室名称" prop="roomName"><el-input v-model="form.roomName" maxlength="64" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="教室编码"><el-input v-model="form.roomCode" maxlength="32" placeholder="留空自动生成" /></el-form-item></el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="分类">
              <el-select v-model="form.categoryId" clearable filterable placeholder="请选择" style="width: 100%;">
                <el-option v-for="c in categoryOptions" :key="c.id" :label="c.categoryName" :value="c.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用途">
              <el-select v-model="form.roomUsage" style="width: 100%;">
                <el-option v-for="u in usageOptions" :key="u.value" :label="u.label" :value="u.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="8"><el-form-item label="容量" prop="capacity"><el-input-number v-model="form.capacity" :min="1" :max="9999" style="width: 100%;" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="楼层"><el-input v-model="form.floor" placeholder="如 3F" maxlength="16" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="面积(㎡)"><el-input-number v-model="form.areaSqm" :min="0" :precision="2" style="width: 100%;" /></el-form-item></el-col>
        </el-row>
        <el-form-item label="位置"><el-input v-model="form.location" maxlength="128" placeholder="楼栋/区域说明" /></el-form-item>
        <el-form-item label="图片">
          <admin-multi-image-upload v-model="form.imageUrls" :limit="9" />
        </el-form-item>
        <el-form-item label="适用课程"><el-input v-model="form.suitableFor" maxlength="256" placeholder="如：少儿舞蹈、拉丁、考级排练" /></el-form-item>

        <el-divider content-position="left">设施配置</el-divider>
        <el-form-item label="标配设施">
          <el-checkbox v-model="form.hasAc" :true-label="1" :false-label="0">空调</el-checkbox>
          <el-checkbox v-model="form.hasProjector" :true-label="1" :false-label="0">投影</el-checkbox>
          <el-checkbox v-model="form.hasSoundSystem" :true-label="1" :false-label="0">音响</el-checkbox>
          <el-checkbox v-model="form.hasMirror" :true-label="1" :false-label="0">舞蹈镜</el-checkbox>
          <el-checkbox v-model="form.hasPiano" :true-label="1" :false-label="0">钢琴</el-checkbox>
          <el-checkbox v-model="form.hasInternet" :true-label="1" :false-label="0">网络</el-checkbox>
        </el-form-item>
        <el-form-item label="器材说明"><el-input v-model="form.equipmentDesc" type="textarea" :rows="2" maxlength="512" placeholder="把杆、地胶、画架、乐器等其他器材" /></el-form-item>

        <el-divider content-position="left">产权与租赁</el-divider>
        <el-form-item label="产权性质">
          <el-radio-group v-model="form.ownershipType">
            <el-radio label="owned">自有/购买</el-radio>
            <el-radio label="rented">租赁</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="form.ownershipType === 'rented'">
          <el-row :gutter="12">
            <el-col :span="12"><el-form-item label="租赁开始" prop="rentStartDate"><el-date-picker v-model="form.rentStartDate" type="date" value-format="yyyy-MM-dd" style="width: 100%;" /></el-form-item></el-col>
            <el-col :span="12"><el-form-item label="租赁结束" prop="rentEndDate"><el-date-picker v-model="form.rentEndDate" type="date" value-format="yyyy-MM-dd" style="width: 100%;" /></el-form-item></el-col>
          </el-row>
          <el-row :gutter="12">
            <el-col :span="12"><el-form-item label="月租金"><el-input-number v-model="form.rentMonthlyFee" :min="0" :precision="2" style="width: 100%;" /></el-form-item></el-col>
            <el-col :span="12"><el-form-item label="出租方"><el-input v-model="form.rentParty" maxlength="128" /></el-form-item></el-col>
          </el-row>
          <el-form-item label="租赁联系人"><el-input v-model="form.rentContact" maxlength="64" /></el-form-item>
          <el-form-item label="租赁备注"><el-input v-model="form.rentRemark" type="textarea" :rows="2" maxlength="256" /></el-form-item>
        </template>

        <el-divider content-position="left">其他</el-divider>
        <el-row :gutter="12">
          <el-col :span="12"><el-form-item label="排序"><el-input-number v-model="form.sortNo" :min="0" :max="9999" style="width: 100%;" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="状态"><el-radio-group v-model="form.status"><el-radio :label="1">启用</el-radio><el-radio :label="0">停用</el-radio></el-radio-group></el-form-item></el-col>
        </el-row>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" maxlength="512" /></el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer"><el-button size="small" @click="formVisible = false">取消</el-button><el-button type="primary" size="small" :loading="saving" @click="submitForm">保存</el-button></div>
    </el-dialog>

    <el-dialog title="教室分类管理" :visible.sync="categoryVisible" width="640px" :close-on-click-modal="false" @open="loadCategories">
      <div style="margin-bottom: 12px;"><el-button type="primary" size="mini" icon="el-icon-plus" @click="openCategoryForm()">新增分类</el-button></div>
      <el-table v-loading="categoryLoading" :data="categoryList" size="small" :border="false">
        <el-table-column prop="categoryName" label="分类名称" min-width="120" />
        <el-table-column prop="categoryCode" label="编码" width="100" />
        <el-table-column prop="roomCount" label="教室数" width="80" align="center" />
        <el-table-column prop="sortNo" label="排序" width="70" align="center" />
        <el-table-column label="状态" width="70" align="center"><template slot-scope="{ row }"><el-tag size="mini" :type="row.status === 1 ? 'success' : 'info'">{{ row.status === 1 ? '启用' : '停用' }}</el-tag></template></el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="openCategoryForm(row)">编辑</el-button>
            <el-button type="text" size="mini" class="admin-pc-table-actions__danger" @click="handleDeleteCategory(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :title="categoryForm.id ? '编辑分类' : '新增分类'" :visible.sync="categoryFormVisible" width="420px" append-to-body :close-on-click-modal="false" @closed="resetCategoryForm">
        <el-form ref="categoryRef" :model="categoryForm" :rules="categoryRules" label-width="80px" size="small">
          <el-form-item label="名称" prop="categoryName"><el-input v-model="categoryForm.categoryName" maxlength="64" /></el-form-item>
          <el-form-item label="编码"><el-input v-model="categoryForm.categoryCode" maxlength="32" placeholder="选填" /></el-form-item>
          <el-form-item label="排序"><el-input-number v-model="categoryForm.sortNo" :min="0" :max="9999" /></el-form-item>
          <el-form-item label="状态"><el-radio-group v-model="categoryForm.status"><el-radio :label="1">启用</el-radio><el-radio :label="0">停用</el-radio></el-radio-group></el-form-item>
          <el-form-item label="备注"><el-input v-model="categoryForm.remark" type="textarea" :rows="2" /></el-form-item>
        </el-form>
        <div slot="footer"><el-button size="small" @click="categoryFormVisible = false">取消</el-button><el-button type="primary" size="small" :loading="categorySaving" @click="submitCategory">保存</el-button></div>
      </el-dialog>
    </el-dialog>
  </admin-page-frame>
</template>
<script>
import AdminPageFrame from './components/AdminPageFrame.vue'
import SchoolListToolbar from './components/SchoolListToolbar.vue'
import SchoolListPagination from './components/SchoolListPagination.vue'
import AdminMultiImageUpload from '../../admin/components/AdminMultiImageUpload.vue'
import schoolListPageMixin from './mixins/school-list-page'
import {
  deleteSchoolRoomCategory,
  fetchSchoolRoomCategories,
  fetchSchoolRoomCategoryOptions,
  fetchSchoolRooms,
  saveSchoolRoom,
  saveSchoolRoomCategory,
  updateSchoolRoom,
  updateSchoolRoomCategory
} from '@/api/h5-admin-schools'
import './schools-admin.less'

const USAGE_OPTIONS = [
  { value: 'teaching', label: '日常教学' },
  { value: 'rehearsal', label: '排练/练功' },
  { value: 'meeting', label: '会议/接待' },
  { value: 'multi', label: '综合多功能' }
]

function emptyForm() {
  return {
    id: null, categoryId: null, roomName: '', roomCode: '', capacity: 10, location: '', floor: '',
    areaSqm: null, roomUsage: 'teaching', hasAc: 0, hasProjector: 0, hasSoundSystem: 0, hasMirror: 0,
    hasPiano: 0, hasInternet: 0, equipmentDesc: '', ownershipType: 'owned', rentStartDate: '', rentEndDate: '',
    rentMonthlyFee: null, rentParty: '', rentContact: '', rentRemark: '', suitableFor: '', imageUrls: [], sortNo: 0, remark: '', status: 1
  }
}

const DEFAULT_QUERY = { keyword: '', categoryId: null, ownershipType: null, status: null, page: 0, size: 20 }

export default {
  name: 'SchoolsRoom',
  components: { AdminPageFrame, SchoolListToolbar, SchoolListPagination, AdminMultiImageUpload },
  mixins: [schoolListPageMixin],
  data() {
    return {
      loading: false, saving: false, list: [], total: 0, categoryOptions: [], usageOptions: USAGE_OPTIONS,
      query: { ...DEFAULT_QUERY }, formVisible: false, form: emptyForm(),
      formRules: {
        roomName: [{ required: true, message: '请输入教室名称', trigger: 'blur' }],
        capacity: [{ required: true, message: '请输入容量', trigger: 'change' }],
        rentStartDate: [{ validator: (r, v, cb) => this.validateRentDate('start', cb), trigger: 'change' }],
        rentEndDate: [{ validator: (r, v, cb) => this.validateRentDate('end', cb), trigger: 'change' }]
      },
      categoryVisible: false, categoryLoading: false, categoryList: [],
      categoryFormVisible: false, categorySaving: false,
      categoryForm: { id: null, categoryName: '', categoryCode: '', sortNo: 0, status: 1, remark: '' },
      categoryRules: { categoryName: [{ required: true, message: '请输入分类名称', trigger: 'blur' }] }
    }
  },
  created() { this.loadCategoryOptions(); this.loadList() },
  methods: {
    ownershipLabel(v) { return v === 'rented' ? '租赁' : '自有' },
    handleReset() { this.resetListQuery(DEFAULT_QUERY) },
    loadCategoryOptions() {
      fetchSchoolRoomCategoryOptions().then(list => { this.categoryOptions = list || [] })
    },
    applyClientFilters(rows) {
      let list = rows || []
      if (this.query.status != null && this.query.status !== '') list = list.filter(r => r.status === this.query.status)
      return list
    },
    loadList() {
      this.loading = true
      const hasClientFilter = this.query.status != null && this.query.status !== ''
      const params = {
        keyword: this.query.keyword || undefined,
        categoryId: this.query.categoryId || undefined,
        ownershipType: this.query.ownershipType || undefined,
        page: hasClientFilter ? 0 : this.query.page,
        size: hasClientFilter ? 500 : this.query.size
      }
      fetchSchoolRooms(params).then(res => {
        let list = (res && res.content) || []
        list = this.applyClientFilters(list)
        if (hasClientFilter) {
          this.total = list.length
          const start = this.query.page * this.query.size
          list = list.slice(start, start + this.query.size)
        } else {
          this.total = (res && res.totalElements) || 0
        }
        this.list = list
      }).finally(() => { this.loading = false })
    },
    validateRentDate(which, cb) {
      if (this.form.ownershipType !== 'rented') { cb(); return }
      if (which === 'start' && !this.form.rentStartDate) { cb(new Error('请选择租赁开始日期')); return }
      if (which === 'end' && !this.form.rentEndDate) { cb(new Error('请选择租赁结束日期')); return }
      if (this.form.rentStartDate && this.form.rentEndDate && this.form.rentStartDate > this.form.rentEndDate) {
        cb(new Error('开始日期不能晚于结束日期')); return
      }
      cb()
    },
    openForm(row) {
      if (row) {
        this.form = {
          id: row.id, categoryId: row.categoryId, roomName: row.roomName, roomCode: row.roomCode || '',
          capacity: row.capacity || 10, location: row.location || '', floor: row.floor || '', areaSqm: row.areaSqm,
          roomUsage: row.roomUsage || 'teaching', hasAc: row.hasAc || 0, hasProjector: row.hasProjector || 0,
          hasSoundSystem: row.hasSoundSystem || 0, hasMirror: row.hasMirror || 0, hasPiano: row.hasPiano || 0,
          hasInternet: row.hasInternet || 0, equipmentDesc: row.equipmentDesc || '',
          ownershipType: row.ownershipType || 'owned', rentStartDate: row.rentStartDate || '', rentEndDate: row.rentEndDate || '',
          rentMonthlyFee: row.rentMonthlyFee, rentParty: row.rentParty || '', rentContact: row.rentContact || '',
          rentRemark: row.rentRemark || '', suitableFor: row.suitableFor || '', imageUrls: Array.isArray(row.imageUrls) ? [...row.imageUrls] : [], sortNo: row.sortNo || 0,
          remark: row.remark || '', status: row.status != null ? row.status : 1
        }
      } else {
        this.resetForm()
      }
      this.formVisible = true
    },
    resetForm() {
      this.form = emptyForm()
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    submitForm() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        this.saving = true
        const req = this.form.id ? updateSchoolRoom(this.form.id, this.form) : saveSchoolRoom(this.form)
        req.then(() => {
          this.$message.success('保存成功')
          this.formVisible = false
          this.loadList()
          this.loadCategoryOptions()
        }).finally(() => { this.saving = false })
      })
    },
    openCategoryMgr() { this.categoryVisible = true },
    loadCategories() {
      this.categoryLoading = true
      fetchSchoolRoomCategories({ page: 0, size: 200 }).then(res => {
        this.categoryList = (res && res.content) || []
      }).finally(() => { this.categoryLoading = false })
    },
    openCategoryForm(row) {
      if (row) {
        this.categoryForm = { id: row.id, categoryName: row.categoryName, categoryCode: row.categoryCode || '', sortNo: row.sortNo || 0, status: row.status != null ? row.status : 1, remark: row.remark || '' }
      } else {
        this.resetCategoryForm()
      }
      this.categoryFormVisible = true
    },
    resetCategoryForm() {
      this.categoryForm = { id: null, categoryName: '', categoryCode: '', sortNo: 0, status: 1, remark: '' }
      this.$nextTick(() => this.$refs.categoryRef && this.$refs.categoryRef.clearValidate())
    },
    submitCategory() {
      this.$refs.categoryRef.validate(valid => {
        if (!valid) return
        this.categorySaving = true
        const req = this.categoryForm.id ? updateSchoolRoomCategory(this.categoryForm.id, this.categoryForm) : saveSchoolRoomCategory(this.categoryForm)
        req.then(() => {
          this.$message.success('保存成功')
          this.categoryFormVisible = false
          this.loadCategories()
          this.loadCategoryOptions()
        }).finally(() => { this.categorySaving = false })
      })
    },
    handleDeleteCategory(row) {
      this.$confirm('确认删除分类「' + row.categoryName + '」？', '提示', { type: 'warning' }).then(() => {
        deleteSchoolRoomCategory(row.id).then(() => {
          this.$message.success('已删除')
          this.loadCategories()
          this.loadCategoryOptions()
        })
      }).catch(() => {})
    }
  }
}
</script>
